import { Component, Input } from '@angular/core';
import { NotificationModel } from '@evorait/pace-core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'pace-contract',
    templateUrl: './contract.component.html',
    styleUrls: ['./contract.component.scss'],
    standalone: false,
})
export class ContractComponent {
    @Input()
    public notification: NotificationModel;
    public constructor(public readonly modalInstance: BsModalRef) {}
}
